
import Modal from "../components/Modal.vue";
import Banner from "../components/Banner.vue";
import Nav from "../components/Nav.vue";
import { defineComponent, reactive, onMounted, toRefs } from "vue";
import axios from "axios";

export default defineComponent({
  components: {Modal, Banner, Nav },
  setup() {
    const state = reactive({
      races: Array,
      indRaces: Array,
      languages: Array,
      trait: Array,
      istrait: false,
    });

    onMounted(async () => {
      const { data } = await axios.get("https://www.dnd5eapi.co/api/races");
      state.races = data.results;
    });

    const showRace = async (index: string) => {
      const { data } = await axios.get(
        `https://www.dnd5eapi.co/api/races/${index}`
      );

      state.indRaces = data;
    };
    function showCards() {
      var element = document.getElementById("race-cards");
      element!.classList.remove("hidden");
    }

    // language
    const lang = async (index: string) => {
      const { data } = await axios.get(
        `https://www.dnd5eapi.co/api/languages/${index}`
      );
      state.istrait = false;
      state.languages = data;
    };

    // trails
    const traits = async (index: string) => {
      const { data } = await axios.get(
        `https://www.dnd5eapi.co/api/traits/${index}`
      );
      state.istrait = true;
      state.trait = data;
    };

    return { ...toRefs(state), showRace, showCards, lang, traits };
  },
});
